import { render, staticRenderFns } from "./PermissionTable.vue?vue&type=template&id=61bcd9e2&scoped=true&"
import script from "./PermissionTable.vue?vue&type=script&lang=js&"
export * from "./PermissionTable.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTable.vue?vue&type=style&index=0&id=61bcd9e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bcd9e2",
  null
  
)

export default component.exports